export default "__VITE_ASSET__BDjugXmr__"